// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import CommunicationContainer from 'modules/onBoarding/components/Communication'

const Communication = (): ReactElement => {
  return (
    <DocumentTitle title={`Step 5 - Communication Preferences | ATD`}>
      <>
        <CommunicationContainer />
      </>
    </DocumentTitle>
  )
}

export default Communication
